var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowSmallLineUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79019 4.18391C8.04766 3.9387 8.45226 3.9387 8.70973 4.18391L11.6264 6.96169C11.893 7.21561 11.9033 7.63759 11.6494 7.90421C11.3955 8.17083 10.9735 8.18113 10.7069 7.9272L8.91663 6.22222L8.91663 11.3333C8.91663 11.7015 8.61815 12 8.24996 12C7.88177 12 7.58329 11.7015 7.58329 11.3333V6.22222L5.79306 7.9272C5.52644 8.18113 5.10446 8.17084 4.85054 7.90421C4.59661 7.63759 4.6069 7.21561 4.87352 6.96169L7.79019 4.18391Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSmallLineUp);
export default __webpack_public_path__ + "static/media/arrowSmallLineUp.6652767aeba5d6deab3020ee5710eb0d.svg";
export { ForwardRef as ReactComponent };